import React from 'react';
import { useSetLocalErrorCallback } from 'js/file_viewer/core/atoms/error';
import { FVError, FVErrorCode, ErrorLifecycle } from 'js/file_viewer/core/types/errors';
import { isFVError } from 'js/file_viewer/core/utils/errors';
import { PreviewsEventLogger, PreviewsTimingEvents } from 'js/file_viewer/logging/performance';
/**
 * Sets the preview metadata to be an error in error cases. This should be called after a preview renderer calls React
 * Query to fetch Riviera data. This is in a hook and not in Redux middleware since React Query does not dispatch to
 * Redux, but our preview metadata is still in Redux.
 * TODO: (htwyford) Our preview metadata is no longer in Redux. Is this still necessary?
 */
export const useRivieraTiming = (result, previewKey, previewData) => {
    const hasLogged = React.useRef(false);
    const setLocalErrorCallback = useSetLocalErrorCallback(previewKey);
    React.useEffect(() => {
        if (hasLogged.current || !previewKey || !(previewData === null || previewData === void 0 ? void 0 : previewData.previewType)) {
            return;
        }
        PreviewsEventLogger.mark(PreviewsTimingEvents.FVSDK_GET_RIVIERA_DATA_START_START);
        if (result.isSuccess) {
            PreviewsEventLogger.mark(PreviewsTimingEvents.FVSDK_GET_RIVIERA_DATA);
            hasLogged.current = true;
        }
        if (result.isError) {
            const error = isFVError(result.error)
                ? result.error
                : new FVError(FVErrorCode.RivieraDataFetchFailure, ErrorLifecycle.Download, result.error.message);
            setLocalErrorCallback(error);
            hasLogged.current = true;
        }
    }, [
        previewData === null || previewData === void 0 ? void 0 : previewData.previewType,
        previewKey,
        result.error,
        result.isError,
        result.isSuccess,
        setLocalErrorCallback,
    ]);
};
//# sourceMappingURL=hooks.preenvesnextjs.map
